module.exports = __webpack_public_path__ + "static/wordpress-f78d8c4da54371bffd84034f3d644326.gif";